module.exports = __webpack_public_path__ + "img/title.8e35bec1.svg";